import n from "./index279.js";
import { resolveComponent as i, createBlock as d, openBlock as o, resolveDynamicComponent as m, mergeProps as u, withCtx as p, createElementBlock as a, createCommentVNode as r, createVNode as h, normalizeClass as l, renderSlot as s } from "vue";
import b from "./index231.js";
const g = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center",
  "data-test-id": "spinner"
};
function f(e, c, S, y, k, v) {
  const t = i("cs-button-loading-spinner");
  return o(), d(m(e.getTag), u({
    class: ["flex items-center transition-colors duration-200 border border-solid ease-ms rounded-normal", {
      "px-16": e.hasDefaultSlot() && !e.isSmall || e.hasDefaultSlot() && e.isSmall && !e.hasIconSlot(),
      "px-8": e.hasDefaultSlot() && e.isSmall && e.hasIconSlot(),
      "justify-center": !e.hasDefaultSlot() || e.isCentered,
      "text-center": e.isCentered,
      "border-color-neutral-black ": !e.isDisabled,
      "active:translate-y-2 hover:bg-color-neutral-black  hover:text-color-neutral-white": !e.isDisabled && !e.isLoading,
      "hover:bg-color-neutral-white border-color-neutral-grey-10 hover:border-color-neutral-grey-10 text-color-neutral-grey-10": e.isDisabled,
      "h-52 min-w-52": !e.isSmall,
      "h-38 min-w-38": e.isSmall,
      "bg-color-neutral-white": e.hasWhiteBackground,
      relative: e.isLoading
    }],
    "data-component": e.$options.name,
    disabled: e.isDisabled || e.isLoading,
    type: e.getType,
    rel: e.getRel,
    target: e.getTarget,
    href: e.getHref,
    "aria-label": e.ariaLabel
  }, e.tracking), {
    default: p(() => [
      e.isLoading ? (o(), a("span", g, [
        h(t, { circleColor: "#E5E5E5" })
      ])) : r("", !0),
      e.hasIconSlot() ? (o(), a("span", {
        key: 1,
        class: l(["w-24 h-24 shrink-0", {
          invisible: e.isLoading
        }]),
        "data-test-id": "icon"
      }, [
        s(e.$slots, "icon")
      ], 2)) : r("", !0),
      e.hasDefaultSlot() ? (o(), a("span", {
        key: 2,
        class: l(["font-bold text-text-l", {
          "ml-8": e.hasIconSlot(),
          invisible: e.isLoading
        }]),
        "data-test-id": "label"
      }, [
        s(e.$slots, "default")
      ], 2)) : r("", !0)
    ]),
    _: 3
  }, 16, ["class", "data-component", "disabled", "type", "rel", "target", "href", "aria-label"]);
}
const L = /* @__PURE__ */ b(n, [["render", f]]);
export {
  L as default
};
